import React, { type JSX } from "react";

const ERROR_PATH =
  "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z";
const SUCCESS_PATH =
  "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z";

/** A coloured banner with a leading status icon. */
function Alert({
  message,
  iconPath,
  boxClass,
  iconClass,
  textClass,
}: {
  message: string;
  iconPath: string;
  boxClass: string;
  iconClass: string;
  textClass: string;
}): JSX.Element {
  return (
    <div className={`border rounded-md p-4 ${boxClass}`}>
      <div className="flex">
        <div className="shrink-0">
          <svg className={`h-5 w-5 ${iconClass}`} viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d={iconPath} clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-3">
          <p className={`text-sm font-medium ${textClass}`}>{message}</p>
        </div>
      </div>
    </div>
  );
}

/** Save/load feedback for the settings page. */
export default function SettingsAlerts({
  error,
  success,
}: {
  error: string | null;
  success: string | null;
}): JSX.Element {
  return (
    <>
      {error && (
        <Alert
          message={error}
          iconPath={ERROR_PATH}
          boxClass="bg-red-50 border-red-200"
          iconClass="text-red-400"
          textClass="text-red-800"
        />
      )}
      {success && (
        <Alert
          message={success}
          iconPath={SUCCESS_PATH}
          boxClass="bg-green-50 border-green-200"
          iconClass="text-green-400"
          textClass="text-green-800"
        />
      )}
    </>
  );
}
